import { render, staticRenderFns } from "./_uid.vue?vue&type=template&id=ba0c2ec6"
import script from "./_uid.vue?vue&type=script&lang=js"
export * from "./_uid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports